import { AbstractLayer } from './abstract-layer';
import { ContextData } from 'src/app/data/context.data';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { TextLayerData } from 'src/app/data/configurator/layer/text-layer.data';
import { WingdingsShapeLayerData } from 'src/app/data/configurator/layer/wingdings-shape-layer.data';
import { HistoryData } from 'src/app/data/configurator/history.data';
import { CommandData } from 'src/app/data/configurator/command.data';

declare const fabric: any;

export class WingdingLayer extends AbstractLayer {


  /**
   * Contructor
   */
  constructor(data: LayerData, stage: any) {
    super(data, stage);
  }

  /**
   * Draw
   */
  protected _draw(): any {
    this._display = new fabric.Text((<WingdingsShapeLayerData>this._data).char, {
      fontSize: 100,
    });

    this._preview = new fabric.Text((<WingdingsShapeLayerData>this._data).char, {
      fontSize: 100,
    });

    super._draw();
  }

  /**
   * Update view
   */
  updateView(): void {

    this._display.set({
      fill: (<WingdingsShapeLayerData>this._data).color,
      fontFamily: (<WingdingsShapeLayerData>this._data).font,
      // scaleX: (<WingdingsShapeLayerData>this._data).width * ContextData.POINTS_TO_PIXELS / 100,
      // scaleY: (<WingdingsShapeLayerData>this._data).height * ContextData.POINTS_TO_PIXELS / 100,
    });

    this._preview.set({
      fill: (<WingdingsShapeLayerData>this._data).color,
      fontFamily: (<WingdingsShapeLayerData>this._data).font,
      // scaleX: (<WingdingsShapeLayerData>this._data).width * ContextData.POINTS_TO_PIXELS / 100,
      // scaleY: (<WingdingsShapeLayerData>this._data).height * ContextData.POINTS_TO_PIXELS / 100,
    });

    super.updateView();
  }

  /**
   * Update data
   */
  updateData(object: any): void {
    let positionData = { x: this.data.x, y: this.data.y, width: this.data.width, height: this.data.height, rotation: this.data.rotation };
    HistoryData.add(this._labelData, this.data, CommandData.SET_POSITION, positionData);

    super.updateData(object);
  }

  /**
   * Cleanup
   */
  public cleanup(): void {

  }
}
